import React from "react";
import { Platform, View } from "react-native";
import { styles } from "./ProductDetails.styles";
import { Input } from "components/Core/Input/Input";
import { useTranslation } from "react-i18next";
import { useFormContext } from "lib/hooks/useFormContext";
import { getInitialValues } from "./ProductDetails.validation";

interface CheckboxesProps {
  categorySku: string;
}

export const Checkboxes = ({
  categorySku,
}: CheckboxesProps): React.ReactElement => {
  const [translate] = useTranslation();
  const { Field } = useFormContext<ReturnType<typeof getInitialValues>>();

  return (
    <>
      <View style={{ alignSelf: "flex-start" }}>
        <Field
          name="prohibitedItems"
          errorStyles={styles.error}
          invertErrorColors
          errorBackground
        >
          {({ field }) => (
            <Input.Checkbox
              {...field}
              inverted={Platform.OS === "web"}
              label={translate("common.acceptProhibitedItems")}
            />
          )}
        </Field>
      </View>

      {categorySku === "SKIPS" && (
        <View style={{ alignSelf: "flex-start" }}>
          <Field
            name="privateLand"
            errorStyles={styles.error}
            invertErrorColors
            errorBackground
          >
            {({ field }) => (
              <Input.Checkbox
                {...field}
                inverted={Platform.OS === "web"}
                label={translate(
                  "hwa.screens.productDetails.privateLandConfirmation",
                )}
              />
            )}
          </Field>
        </View>
      )}
    </>
  );
};
